import React from 'react';
import { Button, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import cs from 'classnames';
import { useHistory } from 'react-router-dom';
import { ReactComponent as MegaphoneIcon } from '../../images/megaphone.svg';
import { priceComparisonLink } from '../../lib/constants';

interface IProps {
  dismissBanner: () => void;
  isActiveCancelled?: boolean;
}

export function CancelledSubscriptionBanner(props: IProps) {
  const { dismissBanner, isActiveCancelled } = props;
  const history = useHistory();

  const bannerTitle = 'Your DigiSign subscription has been cancelled';
  const bannerSubtitle = isActiveCancelled
    ? 'You still have full access until the end of your billing cycle. Want to keep DigiSign running smoothly? Reactivate today.'
    : 'Changed your mind? You can reactivate your subscription anytime for full access to SkySlope DigiSign.';

  function handleActionClick() {
    history.push({
      pathname: '/subscriptions',
      state: {
        url: window.location.href,
        data: { navigatedToSubscriptions: true },
      },
    });
  }

  return (
    <>
      {/* MOBILE VERSION */}
      <details
        id="mobile-cancelled-banner-wrapper"
        data-spec="mobile-cancelled-banner"
        data-testid="mobile-cancelled-banner"
        style={{ position: 'absolute', top: '96px', zIndex: 9999 }}
        className={cs(
          'group',
          'md:hidden',
          'bg-gradient-to-r from-[#533DB1] to-blue-400',
          'flex flex-col justify-between items-center w-full'
        )}
      >
        <summary className="flex justify-between w-full items-center py-6 px-10">
          <span
            data-spec="cancelled-banner-title"
            data-testid="cancelled-banner-title"
            className="mb-1 font-bold max-w-[240px]"
          >
            {bannerTitle}
          </span>
          <ExpandLessIcon className="hidden group-open:block" />
          <ExpandMoreIcon className="group-open:hidden" />
        </summary>

        <div className="flex flex-col justify-between w-full">
          <span className="py-7 px-10">{bannerSubtitle}</span>

          <Button className="shadow-none mx-8" variant="contained" onClick={() => handleActionClick()}>
            Restart Subscription
          </Button>
          <Button className="text-white py-6" variant="text" onClick={() => window.open(priceComparisonLink, '_blank')}>
            Learn More
          </Button>
          <Button className="text-white py-6" variant="text" onClick={dismissBanner}>
            Remind Me later
          </Button>
        </div>
      </details>

      {/* DESKTOP VERSION */}
      <div
        data-spec="cancelled-banner"
        data-testid="cancelled-banner"
        className={cs(
          'hidden md:flex items-center',
          'bg-gradient-to-r from-[#533DB1] to-blue-400',
          'w-full min-h-[90px]',
          'pl-2 pr-4'
        )}
      >
        <IconButton className="text-white mr-3 hover:bg-white/10" onClick={dismissBanner} aria-label="Close">
          <CloseIcon />
        </IconButton>

        <MegaphoneIcon className="hidden xl:block my-0 mr-4" />

        <div>
          <p data-spec="cancelled-banner-title" data-testid="cancelled-banner-title" className="mb-1 font-bold">
            {bannerTitle}
          </p>
          <p>{bannerSubtitle}</p>
        </div>

        <Button
          className="text-white mr-4 ml-auto hover:bg-white/10"
          variant="text"
          onClick={() => window.open(priceComparisonLink, '_blank')}
        >
          Learn More
        </Button>
        <Button variant="contained" onClick={() => handleActionClick()}>
          Restart Subscription
        </Button>
      </div>
    </>
  );
}
